import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();

  const filters = {
    SYSTEM: "System",
    DESIGN: "Design",
    BRAND: "Brand",
    PHOTOS: "Photos",
  };

  const projectsData = [
    {
      title: "visitSrilanka.co",
      projectInfo:
        " Fully-fledged website featuring all travel experiences and destinations for a niche inbound tour operator in Sri Lanka specializing in eco , adventure and other niche categories .",
      client: "visit Sri Lanka Pvt Ltd.",
      technologies: " HTML5, CSS3, PHP, WP",
      industry: "Design , Development , Testing & maintenance along with Branding ",
      date: " January , 2023",
      url: {
        name: "www.visitsrilanka.co",
        link: "https://www.visitsrilanka.co",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/visitsrilanka.co",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "https://www.instagram.com/visitsrilanka.co/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/project-1.jpg",
      sliderImages: [
        "images/projects/project-1-1.jpg",
        "images/projects/project-1-2.jpg",
      ],
      categories: [filters.SYSTEM],
    },
    {
      title: "3dihome.co",
      projectInfo:
        "Website & branding for 3dihome - Crafting ideas into real world products through cutting edge 3 D printing technology in Colombo Sri Lanka.",
      client: "3diHome Pvt Ltd",
      technologies: "HTML5, CSS3, PHP, CMS , branding kits",
      industry: " Branding",
      date: "November , 2022",
      url: {
        name: "www.3dihome.co",
        link: "https://www.3dihome.co",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/3DiHome/",
        instagram: "https://www.instagram.com/3dihome/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/project-2.jpg",
      sliderImages: [
        "images/projects/project-2-1.jpg",
        "images/projects/project-2-2.jpg",
      ],
      categories: [filters.DESIGN],
    },
    {
      title: "Bawwo - The veterinary Hospital",
      projectInfo:
        "State of art veterinary Hospital startup in Galle Sri Lanka offering wide variety of pet services.",
      client: "Lakshitha Hasith Nanayakkara",
      technologies: " HTML5, CSS3, PHP, Java",
      industry: "Concept , Design , Development & Branding",
      date: "August , 2018",
      url: {
        name: "www.bawwo.lk",
        link: "https://www.bawwo.lk",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/bawwo.lk//",
        instagram: "https://www.instagram.com/bawwo_the_veterinary_hospital",
        mail: "mailto:doc@bawwo.lk",
      },
      thumbImage: "images/projects/project-3.jpg",
      sliderImages: [
        "images/projects/project-3-1.jpg",
        "images/projects/project-3-2.jpg",
      ],
      categories: [filters.BRAND],
    },
    {
      title: "Inspired Inc Co",
      projectInfo:
        "The branding company based in Colombo Sri Lanka who specialize in designing & social media marketing projects.",
      client: "Inspired Inc pvt Ltd",
      technologies: "HTML5, CSS3, PHP, Java",
      industry: "Design & Branding",
      date: "February , 2023",
      url: {
        name: "www.inspiredinc.co",
        link: "https://www.inspiredinc.co",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/project-4.jpg",
      sliderImages: [
        "images/projects/project-4.jpg",
        "images/projects/project-4.jpg",
      ],
      categories: [filters.BRAND, filters.DESIGN],
    },
    {
      title: "Eclectic",
      projectInfo:
        ".",
      client: "Owned  by self",
      technologies: "Adobe , HTML5, CSS3, PHP",
      industry: "Photography",
      date: " Since 2017",
      url: {
        name: "www.eclectic.lk",
        link: "https://www.eclectic.poornaabey.com",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/eclectic.lk",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "https://www.flickr.com/people/eclecticlk//",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/project-5.jpg",
      sliderImages: [
        "images/projects/project-5-1.jpg",
        "images/projects/project-5-2.jpg",
      ],
      categories: [filters.PHOTOS],
    },
    {
      title: "Power Hands Plantation",
      projectInfo:
        " Power Hands Plantation specializes in vanilla cultivation with investment plans for its investors.",
      client: "Power Hands Plantation",
      technologies: "HTML5, CSS3, PHP",
      industry: "Web Design",
      date: " August, 2019",
      url: {
        name: "www.powerhandsplantation.com",
        link: "https://www.powerhandsplantation.com/",
      },
      socialLinks: {
        facebook: "https://www.facebook.com/Powerhands2019//",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "https://www.instagram.com/powerhands_plantation_/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/project-6.jpg",
      sliderImages: [
        "images/projects/project-6-1.jpg",
        "images/projects/project-6-2.jpg",
      ],
      categories: [filters.DESIGN],
    },
    /* {
      title: "Project Title 7",
      projectInfo:
        "Quidam lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure. Lisque persius interesset his et, in quot quidam persequeris vim, ad mea essent possim iriure.",
      client: "Ruby Clinton",
      technologies: "iOS, HTML5, CSS3, PHP, Java",
      industry: "Art & Design",
      date: "July 16, 2019",
      url: {
        name: "www.example.com",
        link: "https://www.example.com",
      },
      socialLinks: {
        facebook: "http://www.facebook.com/",
        twitter: "http://www.twitter.com/",
        google: "http://www.google.com/",
        instagram: "http://www.instagram.com/",
        mail: "mailto:example@gmail.com",
      },
      thumbImage: "images/projects/project-7.jpg",
      sliderImages: [
        "images/projects/project-1.jpg",
        "images/projects/project-5.jpg",
      ],
      categories: [filters.DESIGN, filters.PHOTOS],
    },
    */
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
              (darkTheme ? "nav-light" : "")
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " +
                    (filterKey === filters[oneKey] ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(filters[oneKey])}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      project.categories.join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <a
                            className="popup-ajax stretched-link"
                            //href=""
                            onClick={() => {
                              setSelectedProjectDetails(projectsData[index]);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          />
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light">Read more</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
